import { TeamHero } from '@/components/sections/team-governance'
import { Team, AdvisoryBoard, StrategicConsultant } from '@/components/sections/about'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const TeamPage = () => {
  usePageTitle('Our Team')

  return (
    <>
      <TeamHero />
      <Team />
      <AdvisoryBoard />
      <StrategicConsultant />
      <FinalCTA />
    </>
  )
}
